/**
 * Canonical Comparison Key Utility (Frontend)
 *
 * Normalizes item names, ingredient names, unit strings for robust comparison
 * across all layers (L1 Purchase, L2 Transfer, L3 Shift Reconcile, L4 Waste, L5 Balance Adjust).
 *
 * Rules:
 * 1. Preserves original strings for presentation and audit logging.
 * 2. For lookups and comparisons:
 *    - Lowercases all characters
 *    - Strips all whitespace (\s)
 *    - Strips all punctuation and special characters: ()[]{} - _ , . / \ : ; ! ? ' " ~ @ # $ % ^ & * + = < > | `
 *
 * Examples:
 * - "Bạc xỉu( Đá)" -> "bạcxỉuđá"
 * - "Bạc xỉu (đá)" -> "bạcxỉuđá"
 * - "Rich's"       -> "richs"
 * - "Richs"        -> "richs"
 */

export function toComparisonKey(str: unknown): string {
  if (str === null || str === undefined) return '';
  return String(str)
    .toLowerCase()
    .replace(/[\s\(\)\[\]\{\}\-_,.\/\\:;!?'"~@#$%^&*+=<>|`\u2018\u2019\u201C\u201D]/g, '');
}

/**
 * Checks if two strings are canonically equal after stripping whitespace and special characters.
 */
export function isCanonicalEqual(a: unknown, b: unknown): boolean {
  const keyA = toComparisonKey(a);
  const keyB = toComparisonKey(b);
  if (!keyA || !keyB) return false;
  return keyA === keyB;
}
